/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataCenterCategory } from './DataCenterCategory';
import {
    DataCenterCategoryFromJSON,
    DataCenterCategoryFromJSONTyped,
    DataCenterCategoryToJSON,
    DataCenterCategoryToJSONTyped,
} from './DataCenterCategory';
import type { DataCenterDashboard } from './DataCenterDashboard';
import {
    DataCenterDashboardFromJSON,
    DataCenterDashboardFromJSONTyped,
    DataCenterDashboardToJSON,
    DataCenterDashboardToJSONTyped,
} from './DataCenterDashboard';

/**
 * 
 * @export
 * @interface DataCenterNavigationCategory
 */
export interface DataCenterNavigationCategory {
    /**
     * 
     */
    category: DataCenterCategory;
    /**
     * 
     */
    dashboards: Array<DataCenterDashboard>;
}



/**
 * Check if a given object implements the DataCenterNavigationCategory interface.
 */
export function instanceOfDataCenterNavigationCategory(value: object): value is DataCenterNavigationCategory {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('dashboards' in value) || value['dashboards'] === undefined) return false;
    return true;
}

export function DataCenterNavigationCategoryFromJSON(json: any): DataCenterNavigationCategory {
    return DataCenterNavigationCategoryFromJSONTyped(json, false);
}

export function DataCenterNavigationCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataCenterNavigationCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'category': DataCenterCategoryFromJSON(json['category']),
        'dashboards': ((json['dashboards'] as Array<any>).map(DataCenterDashboardFromJSON)),
    };
}

export function DataCenterNavigationCategoryToJSON(json: any): DataCenterNavigationCategory {
    return DataCenterNavigationCategoryToJSONTyped(json, false);
}

export function DataCenterNavigationCategoryToJSONTyped(value?: DataCenterNavigationCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': DataCenterCategoryToJSON(value['category']),
        'dashboards': ((value['dashboards'] as Array<any>).map(DataCenterDashboardToJSON)),
    };
}

